import React from "react";
import CardWithImage from "../../component/Card/FeaturedApps";
import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";

const cards = [
  {
    heading: "Dashboard",
    role: "Role          - Tech Lead",
    context: "Context       - Manage IoT devices",
    Available: "Available for - Desktop, Mobile",
    alt: "wendor-dashboard",
    img: "./websites/dashboard.png",
    imgHeight: "auto",
    imgWidht: "100%",
    tagList: ["React", "PWA", "Rest API", "Jenkins", "Redux"],
  },
  {
    heading: "Kiosk",
    role: "Role          - Tech Lead",
    context: "Context       - Vending machine's Touch screen app",
    alt: "wendor-dashboard",
    imgHeight: "auto",
    imgWidht: "100%",
    img: "./websites/kiosk.png",
    Available: "Available for -Vending machine",
    tagList: ["React", "PWA", "Rest API", "Jenkins", "Redux", "MQTT"],
  },
  {
    heading: "Service mode app",
    role: "Role          - Tech Lead",
    context: "Context       - Vending machine's Touch screen app",
    alt: "wendor-dashboard",
    imgHeight: "auto",
    imgWidht: "100%",
    img: "./websites/serviceMode.png",
    Available: "Available for -Vending machine",
    tagList: ["React", "PWA", "Rest API"],
  },
  {
    heading: "CRUD app",
    role: "Role          - Owner (open source)",
    context: "Context       - Basic CRUD app",
    alt: "Service mode",
    imgHeight: "auto",
    imgWidht: "100%",
    img: "./websites/reddit.png",
    Available: "Available for - NONE ",
    tagList: ["React", "PWA", "Rest API", "Graphql", "Typescrypt", "Postgres"],
  },
];

const Websites = () => (
  <Jumbotron flexDirection="column" width="100%">
    <Text
      text="FEATURED APPS"
      fs="60px"
      margin="5px auto"
      textAlign="center"
      fontWeight="bold"
    />

    <Jumbotron  flexDirection="column" width="100%" margin="0px" padding="0 30px">
      {cards.map((card) => (
        <CardWithImage key={card.heading} justifyContent="center" {...card} />
      ))}
    </Jumbotron>
  </Jumbotron>
);

export default Websites;
